/**
 * Judge.me injects its widget CSS after theme styles, so hover/scale
 * overrides need to be re-applied once the Write a review button exists.
 * Also converts the reviews list into a testimonial-style horizontal carousel.
 */
(function () {
  var STYLE_ID = 'accelia-judgeme-button-overrides';
  var CSS =
    '#product-reviews button[data-testid="write-review-button"],' +
    '#judgeme_product_reviews button[data-testid="write-review-button"],' +
    '#product-reviews .jm-action-buttons__button.jm-button--primary,' +
    '#judgeme_product_reviews .jm-action-buttons__button.jm-button--primary,' +
    '#product-reviews .jm-review-widget-minimal-header__action-buttons .jm-button,' +
    '#judgeme_product_reviews .jm-review-widget-minimal-header__action-buttons .jm-button{' +
    'font-family:var(--font-primary)!important;' +
    'font-size:16px!important;' +
    'font-weight:400!important;' +
    'line-height:1.3!important;' +
    'letter-spacing:-0.16px!important;' +
    'border-radius:5px!important;' +
    'border:none!important;' +
    'background:var(--color_black)!important;' +
    'background-color:var(--color_black)!important;' +
    'color:var(--color_neutral_dark)!important;' +
    'padding:12px 24px!important;' +
    'cursor:pointer!important;' +
    'transition:transform 0.15s cubic-bezier(0.4,0,0.2,1),scale 0.15s cubic-bezier(0.4,0,0.2,1)!important;' +
    'transform:none;' +
    'scale:1;' +
    '}' +
    '#product-reviews button[data-testid="write-review-button"]:hover,' +
    '#judgeme_product_reviews button[data-testid="write-review-button"]:hover,' +
    '#product-reviews .jm-action-buttons__button.jm-button--primary:hover,' +
    '#judgeme_product_reviews .jm-action-buttons__button.jm-button--primary:hover,' +
    '#product-reviews .jm-review-widget-minimal-header__action-buttons .jm-button:hover,' +
    '#judgeme_product_reviews .jm-review-widget-minimal-header__action-buttons .jm-button:hover,' +
    '#product-reviews button[data-testid="write-review-button"]:active,' +
    '#judgeme_product_reviews button[data-testid="write-review-button"]:active,' +
    '#product-reviews .jm-action-buttons__button.jm-button--primary:active,' +
    '#judgeme_product_reviews .jm-action-buttons__button.jm-button--primary:active,' +
    '#product-reviews .jm-review-widget-minimal-header__action-buttons .jm-button:active,' +
    '#judgeme_product_reviews .jm-review-widget-minimal-header__action-buttons .jm-button:active{' +
    'transform:scale(0.97)!important;' +
    'scale:0.97!important;' +
    'opacity:1!important;' +
    '}';

  // Prefer precise Judge.me review roots only (avoid nested matches).
  var CARD_SELECTOR = '.jdgm-rev, .jm-review-item, [data-testid="review-item"]';

  function injectStyles() {
    var existing = document.getElementById(STYLE_ID);
    if (existing) {
      document.head.appendChild(existing);
      return;
    }
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function hasWriteButton(root) {
    return !!(root || document).querySelector(
      'button[data-testid="write-review-button"], .jm-action-buttons__button.jm-button--primary'
    );
  }

  /** Keep only outermost nodes — drop any candidate nested inside another. */
  function outermostOnly(nodes) {
    return nodes.filter(function (node) {
      return !nodes.some(function (other) {
        return other !== node && other.contains(node);
      });
    });
  }

  function findReviewCards(section) {
    var matches = Array.prototype.slice.call(section.querySelectorAll(CARD_SELECTOR));
    matches = outermostOnly(matches);

    if (matches.length >= 2) {
      // Prefer a single shared parent (the real reviews list).
      var bestParent = null;
      var bestKids = [];
      var groups = new Map();

      matches.forEach(function (card) {
        var parent = card.parentElement;
        if (!parent) return;
        if (!groups.has(parent)) groups.set(parent, []);
        groups.get(parent).push(card);
      });

      groups.forEach(function (kids, parent) {
        if (kids.length > bestKids.length) {
          bestKids = kids;
          bestParent = parent;
        }
      });

      if (bestParent && bestKids.length >= 2) {
        // Only direct children of that list — never nested descendants.
        return Array.prototype.filter.call(bestParent.children, function (child) {
          return child.matches(CARD_SELECTOR);
        });
      }
    }

    return matches;
  }

  function getTrackCards(track) {
    if (!track) return [];
    return Array.prototype.filter.call(track.children, function (child) {
      return child.classList.contains('judge-me-reviews-carousel__card');
    });
  }

  function createNavButton(direction) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className =
      'judge-me-reviews-carousel__btn judge-me-reviews-carousel__btn--' + direction;
    btn.setAttribute('aria-label', direction === 'prev' ? 'Previous reviews' : 'Next reviews');
    btn.setAttribute('data-disabled', direction === 'prev' ? 'true' : 'false');
    btn.innerHTML =
      direction === 'prev'
        ? '<svg class="judge-me-reviews-carousel__btn-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg class="judge-me-reviews-carousel__btn-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12H19M12 5L19 12L12 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return btn;
  }

  function ensureCarouselShell(section, cards) {
    var existing = section.querySelector('.judge-me-reviews-carousel');
    if (existing) return existing;

    var firstCard = cards[0];
    var list = firstCard.parentElement;
    if (!list) return null;

    var carousel = document.createElement('div');
    carousel.className = 'judge-me-reviews-carousel';

    var nav = document.createElement('div');
    nav.className = 'judge-me-reviews-carousel__nav';
    nav.appendChild(createNavButton('prev'));
    nav.appendChild(createNavButton('next'));

    var viewport = document.createElement('div');
    viewport.className = 'judge-me-reviews-carousel__viewport';

    list.parentNode.insertBefore(carousel, list);
    carousel.appendChild(nav);
    carousel.appendChild(viewport);
    viewport.appendChild(list);

    return carousel;
  }

  function cardSize() {
    if (window.innerWidth <= 767) {
      return Math.min(406, window.innerWidth - 48);
    }
    return 406;
  }

  function stampClasses(cards, list) {
    var size = cardSize();

    if (list) {
      list.classList.add('judge-me-reviews-carousel__track');
      list.style.setProperty('display', 'flex', 'important');
      list.style.setProperty('flex-wrap', 'nowrap', 'important');
      list.style.setProperty('gap', '24px', 'important');
      list.style.setProperty('width', 'max-content', 'important');
      list.style.setProperty('max-width', 'none', 'important');
      list.style.setProperty('grid-template-columns', 'none', 'important');
      // Don't zero out padding — CSS adds trailing space after the last card
      list.style.removeProperty('padding');
      list.style.removeProperty('padding-right');
    }

    // Strip card class from any nested leftovers first
    if (list) {
      list.querySelectorAll('.judge-me-reviews-carousel__card').forEach(function (el) {
        if (el.parentElement !== list) {
          el.classList.remove('judge-me-reviews-carousel__card');
          el.style.removeProperty('flex');
          el.style.removeProperty('width');
          el.style.removeProperty('max-width');
          el.style.removeProperty('min-width');
        }
      });
    }

    cards.forEach(function (card) {
      // Never stamp nested nodes
      if (list && card.parentElement !== list) return;

      card.classList.add('judge-me-reviews-carousel__card');
      card.style.setProperty('flex', '0 0 ' + size + 'px', 'important');
      card.style.setProperty('width', size + 'px', 'important');
      card.style.setProperty('max-width', size + 'px', 'important');
      card.style.setProperty('min-width', size + 'px', 'important');
      card.style.setProperty('float', 'none', 'important');
      card.style.setProperty('display', 'flex', 'important');
      card.style.setProperty('flex-direction', 'column', 'important');
      card.style.setProperty('box-sizing', 'border-box', 'important');
      card.style.setProperty('margin', '0', 'important');
    });
  }

  function initCarousel(section) {
    if (!section || section.dataset.jmCarouselInit === 'true') return;

    var cards = findReviewCards(section);
    if (cards.length < 2) return;

    var list = cards[0].parentElement;
    var carousel = ensureCarouselShell(section, cards);
    if (!carousel) return;

    section.dataset.jmCarouselInit = 'true';
    stampClasses(cards, list);

    var track = carousel.querySelector('.judge-me-reviews-carousel__track') || list;
    var viewport = carousel.querySelector('.judge-me-reviews-carousel__viewport');
    var prevBtn = carousel.querySelector('.judge-me-reviews-carousel__btn--prev');
    var nextBtn = carousel.querySelector('.judge-me-reviews-carousel__btn--next');
    var currentIndex = 0;
    var cardNodes = getTrackCards(track);
    var GAP = 24;

    function refreshCards() {
      cardNodes = getTrackCards(track);
      if (!cardNodes.length) {
        cardNodes = findReviewCards(section);
        stampClasses(cardNodes, track);
        cardNodes = getTrackCards(track);
      }
    }

    function stepWidth() {
      if (!cardNodes.length) return 0;
      return cardNodes[0].offsetWidth + GAP;
    }

    function getVisibleWidth() {
      var el = viewport || track.parentElement;
      if (!el) return 0;
      var style = getComputedStyle(el);
      return el.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
    }

    function getMaxTranslate() {
      if (!cardNodes.length || !track) return 0;
      // Use scrollWidth so track padding-right (end margin) is included
      return Math.max(0, track.scrollWidth - getVisibleWidth());
    }

    function maxIndex() {
      var step = stepWidth();
      if (step <= 0) return 0;
      return Math.ceil(getMaxTranslate() / step);
    }

    function getTranslate() {
      var maxIdx = maxIndex();
      var maxTranslate = getMaxTranslate();
      if (currentIndex >= maxIdx) return maxTranslate;
      return currentIndex * stepWidth();
    }

    function updateSlider() {
      refreshCards();
      if (!cardNodes.length) return;

      stampClasses(cardNodes, track);
      cardNodes = getTrackCards(track);

      var maxIdx = maxIndex();
      currentIndex = Math.min(Math.max(0, currentIndex), maxIdx);
      track.style.transform = 'translateX(-' + getTranslate() + 'px)';

      if (prevBtn && nextBtn) {
        if (getMaxTranslate() <= 0) {
          prevBtn.style.display = 'none';
          nextBtn.style.display = 'none';
        } else {
          prevBtn.style.display = '';
          nextBtn.style.display = '';
          prevBtn.setAttribute('data-disabled', currentIndex === 0 ? 'true' : 'false');
          nextBtn.setAttribute('data-disabled', currentIndex >= maxIdx ? 'true' : 'false');
        }
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (currentIndex < maxIndex()) {
          currentIndex++;
          updateSlider();
        }
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (currentIndex > 0) {
          currentIndex--;
          updateSlider();
        }
      });
    }

    var startX = 0;
    var currentX = 0;
    var isSwiping = false;

    track.addEventListener(
      'touchstart',
      function (e) {
        startX = e.touches[0].clientX;
        currentX = startX;
        isSwiping = true;
        track.style.transition = 'none';
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      function (e) {
        if (!isSwiping) return;
        currentX = e.touches[0].clientX;
        var diffX = currentX - startX;
        var baseTranslate = -getTranslate();
        var newTranslate = baseTranslate + diffX;
        var maxTranslate = 0;
        var minTranslate = -getMaxTranslate();

        if (newTranslate > maxTranslate) {
          newTranslate = maxTranslate + (newTranslate - maxTranslate) * 0.3;
        } else if (newTranslate < minTranslate) {
          newTranslate = minTranslate + (newTranslate - minTranslate) * 0.3;
        }

        track.style.transform = 'translateX(' + newTranslate + 'px)';
      },
      { passive: true }
    );

    track.addEventListener('touchend', function () {
      if (!isSwiping) return;
      isSwiping = false;
      track.style.transition = '';

      var diffX = currentX - startX;
      if (Math.abs(diffX) > 50) {
        if (diffX > 0 && currentIndex > 0) {
          currentIndex--;
        } else if (diffX < 0 && currentIndex < maxIndex()) {
          currentIndex++;
        }
      }

      updateSlider();
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentIndex = Math.min(currentIndex, maxIndex());
        track.style.transition = 'none';
        updateSlider();
        requestAnimationFrame(function () {
          track.style.transition = '';
        });
      }, 150);
    });

    updateSlider();
    window.setTimeout(updateSlider, 300);
    window.setTimeout(updateSlider, 1000);
  }

  function init(section) {
    if (!section) return;
    injectStyles();
    initCarousel(section);

    if (hasWriteButton(section) && section.dataset.jmCarouselInit === 'true') return;

    var observer = new MutationObserver(function () {
      injectStyles();
      initCarousel(section);
      if (hasWriteButton(section) && section.dataset.jmCarouselInit === 'true') {
        observer.disconnect();
      }
    });

    observer.observe(section, { childList: true, subtree: true });

    window.setTimeout(function () {
      injectStyles();
      initCarousel(section);
    }, 1500);
    window.setTimeout(function () {
      injectStyles();
      initCarousel(section);
    }, 4000);
  }

  function boot() {
    var roots = document.querySelectorAll('.judge-me-reviews-section');
    if (!roots.length) {
      roots = document.querySelectorAll('#product-reviews');
    }
    roots.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target.querySelector('.judge-me-reviews-section, #product-reviews') ||
      event.target;
    if (section && section.dataset) {
      delete section.dataset.jmCarouselInit;
    }
    init(section);
  });
})();
